
My account page
<!-- 
<div class="container text-center my-5" *ngIf="isAuthenticated && (roleService.role$ | async) === 'admin'">
  <div class="accountLandingEditAdmin">
    <div *ngIf="errorMessage">
      <p>{{ errorMessage }}</p>
    </div>
    <div *ngIf="!errorMessage">
      <div [innerHTML]="safeContent"></div>
    </div>
  </div>
  <br />
</div>

<div class="container text-center my-5" *ngIf="isAuthenticated && (roleService.role$ | async) === 'user'">
  <div class="accountLandingEditUser">
    <div *ngIf="errorMessage">
      <p>{{ errorMessage }}</p>
    </div>
    <div *ngIf="!errorMessage">
      <div [innerHTML]="safeContent"></div>
    </div>
  </div>
  <br />
</div>

<div class="container text-center my-5" *ngIf="isAuthenticated && (roleService.role$ | async) === 'paiduser'">
  <div class="accountLandingEditPaidUser">
    <div *ngIf="errorMessage">
      <p>{{ errorMessage }}</p>
    </div>
    <div *ngIf="!errorMessage">
      <div [innerHTML]="safeContent"></div>
    </div>
  </div>
  <br />
</div> -->

